import React, { useEffect } from 'react';
import '@/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import buildInfo from './buildInfo';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { store } from '@/store/store';
//import ProtectedRoute from '@/routes/ProtectedRoute';
import LoginView from './views/LoginView';
//import MunicipalidadLayout from './layouts/MunicipalidadLayout';
import UnauthorizedView from './views/UnauthorizedView';
import SignOutView from './views/SignOutView';
import NotFoundView from './views/NotFoundView';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import MunicipalidadLayout from './layouts/MunicipalidadLayout';
import HomeView from './views/HomeView';
import DecretosView from './views/DecretosView';
import OrdenanzasView from './views/OrdenanzasView';
import VehiculosView from './views/VehiculosView';
import BoletinesView from './views/BoletinesView';
import AreasView from './views/AreasView';
import EjecutivoView from './views/EjecutivoView';
import ConcejoView from './views/ConcejoView';
import ObservatorioView from './views/ObservatorioView';
import PlanEstrategicoView from './views/PlanEstrategicoView';
import EstadosContablesView from './views/EstadosContablesView';
import SueldosView from './views/SueldosView';

let persistor = persistStore(store);

/* const AppLoader = () => (
  <Loader id="full-screen-loader" size="big" indeterminate>
    Preparing app...
  </Loader>
); */

const AppLoader = () => <div>Preparing app... </div>;

const App = () => {
  useEffect(() => {
    const { buildDate, buildVersion } = buildInfo;
    console.log(`Build Number: ${buildVersion}`);
    console.log(`Build Date: ${new Date(buildDate).toString()}`);
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <Provider store={store}>
        <PersistGate loading={<AppLoader />} persistor={persistor}>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginView />}></Route>
              <Route path="/unauthorized" element={<UnauthorizedView />} />
              <Route path="/sign-out" element={<SignOutView />} />
              <Route path="/notfound" element={<NotFoundView />} />
              <Route element={<MunicipalidadLayout />}>
                <Route path="/" element={<HomeView />}></Route>
                <Route path="/home" element={<HomeView />} />
                <Route path="/solicitud-decretos" element={<DecretosView />} />
                <Route path="/consulta-ordenanzas" element={<OrdenanzasView />} />
                <Route path="/seguimiento-vehiculos" element={<VehiculosView />} />
                <Route path="/boletines-oficiales" element={<BoletinesView />} />
                <Route path="/areas" element={<AreasView />} />
                <Route path="/ejecutivo" element={<EjecutivoView />} />
                <Route path="/concejo-deliverante" element={<ConcejoView />} />
                <Route path="/observatorio-vial" element={<ObservatorioView />} />
                <Route path="/plan-estrategico" element={<PlanEstrategicoView />} />
                <Route path="/estados-contables" element={<EstadosContablesView />} />
                <Route path="/sueldos" element={<SueldosView />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </DndProvider>
  );
};

export default React.memo(App);
